export default {
  title: 'Tablet de fidelización',
  headers: {
    customer_frequency: 'Frecuencia de clientes',
  },
};
